import * as React from "react";
import {Item} from "components/models/Quotation";
import NumberFormat from 'react-number-format';
import Card from "react-bootstrap/Card";
import Table from "react-bootstrap/Table";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Components from "components/quotation/Components";
import Form from "react-bootstrap/Form";

interface Props {
  items: Item[],
  onAdd: (item: Item) => void;
}

interface State {
  active?: Item;
  newItem?: Item;
}

export default class extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);
    this.state = {};
  }


  items() {
    if (this.props.items.length === 0) {
      return (<tr className={"text-center"}>
        <td colSpan={6}><i>No items</i></td>
      </tr>)
    }

    return this.props.items.map((i) =>
      (<tr key={`${i.number}-${i.name}`}>
        <td>{i.number.toString().padStart(6, "0")}</td>
        <td>{i.name}</td>
        <td className="text-right"><NumberFormat value={i.adjustment.cents / 100} prefix={"£"} displayType={"text"}
                                                 thousandSeparator={true}
                                                 decimalScale={2} fixedDecimalScale={true}/></td>
        <td className="text-right"><NumberFormat value={i.adjustment.cents / 100} prefix={"£"} displayType={"text"}
                                                 thousandSeparator={true}
                                                 decimalScale={2} fixedDecimalScale={true}/></td>
        <td>...</td>
        <td className={"pr-4"}><Button size="sm" variant={i === this.state.active ? "secondary" : "outline-secondary"}
                                       onClick={() => this.toggleActive(i)}>Edit</Button></td>
      </tr>)
    )
  }

  toggleActive(item: Item) {
    this.setState({active: item === this.state.active ? undefined : item})
  }

  showAddItem() {
    // TODO: Make item a class?
    this.setState((state) => ({
      newItem: {
        name: "",
        number: Math.max(...this.props.items.map((i) => i.number)) + 1,
        _id: "",
        adjustment: {cents: 0, currency_iso: "GBP"},
        components: []
      }
    }));
  }

  closeAddItem() {
    this.setState({newItem: undefined})
  }

  addItem() {
    if (this.state.newItem) {
      this.props.onAdd(this.state.newItem);
    }
    this.closeAddItem();
  }

  render() {
    return <>
      <Card className="mb-4">
        <Card.Header className="d-flex justify-content-between py-3">
          <div className="align-self-center">
            Items
          </div>
          <div className="align-self-center">
            {<Button variant="primary" size="sm" onClick={() => this.showAddItem()}>Add</Button>}
          </div>
        </Card.Header>
        <Table className="padded no-top-border">
          <thead>
          <tr>
            <th>Number</th>
            <th>Item</th>
            <th className="text-right">Adjustment</th>
            <th className="text-right">Item Price</th>
            <th>Order?</th>
            <th className="w5p">&nbsp;</th>
          </tr>
          </thead>
          <tbody>{this.items()}</tbody>
        </Table>
      </Card>
      {this.state.active && <Components item={this.state.active}/>}

      {/* TODO: Move to own component */}
      <Modal show={!!this.state.newItem} onHide={() => this.closeAddItem()}>
        <Form onSubmit={(e) => {
          e.preventDefault();
          this.addItem()
        }}>
          <Modal.Header closeButton>
            <Modal.Title>Add Item</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group controlId="formBasicEmail">
              <Form.Label>Item Name</Form.Label>
              <Form.Control type="text" value={this.state.newItem?.name}
                            onChange={(e) => this.setState((state) => ({newItem: Object.assign(state.newItem, {name: e.target.value})}))}
                            placeholder="Name"/>
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => this.closeAddItem()}>
              Cancel
            </Button>
            <Button variant="primary" onClick={() => this.addItem()}>
              Add Item
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  }
}